import React from "react";
import { ContentLayout } from "@cloudscape-design/components";
import { TrajectoryLoader } from "../Loaders";

interface LoadingScreenProps {
  message?: string;
  size?: string;
  speed?: string;
}

export const LoadingScreen: React.FC<LoadingScreenProps> = ({
  message = "Loading...",
  size = "140px",
  speed = "2s"
}) => (
  <ContentLayout defaultPadding>
    <div className="loading-state">
      <TrajectoryLoader size={size} speed={speed} />
      <div className="loading-message">
        {message}
      </div>
    </div>
  </ContentLayout>
);
